import ITSImage from "@/components/ITSImage/ITSImage";
import { SearchWebResultType } from "@/lib/types/search/results";
import Link from "next/link";
import styles from './SearchWebThumbnail.module.scss';
import { PromotedResultType } from "@/lib/content-services/search/promotedResults";
interface SearchWebThumbnailProps {
  data: SearchWebResultType | PromotedResultType;
}
export default function SearchWebThumbnail(props: SearchWebThumbnailProps) {
  const {
    data
  } = props;
  const {
    title,
    external_url,
    image_url
  } = data;
  if (Object.hasOwn(data, 'description_short')) {
    var description = (data as SearchWebResultType).description_short;
  } else {
    var description = (data as PromotedResultType).description;
  }
  return <div className={styles.search_web_thumbnail__container} data-sentry-component="SearchWebThumbnail" data-sentry-source-file="SearchWebThumbnail.tsx">
      <div className={styles.search_web_thumbnail}>
        {image_url ? <Link href={external_url} style={{
        backgroundImage: `url(${`${image_url}?blur=20`})`
      }} className={styles.search_web_thumbnail__link}>
            <ITSImage src={image_url} alt='' width={500} className={styles.search_web_thumbnail__image} />
          </Link> : <Link href={external_url} className={styles.search_web_thumbnail__fallback_link} />}
        <h3 className={styles.search_web_thumbnail__title}>
          <Link href={external_url} data-sentry-element="Link" data-sentry-source-file="SearchWebThumbnail.tsx">{title}</Link>
        </h3>
        <p className={styles.search_web_thumbnail__description}>
          {description}
        </p>
      </div>
    </div>;
}